import { useEffect } from 'react';
import { useViewSlackChannelsQuery } from '../services/api';
import { errorToast } from '../utils/toasts';

/**
 * Fetch slack channels (acceptable params are id)
 * The parameters are optional
 */
export const useFetchSlackChannels = ({ id } = {}) => {
  const { data, error, isError, isFetching, isLoading } = useViewSlackChannelsQuery({
    id,
  });

  useEffect(() => {
    if (isError) {
      errorToast('Unable to fetch slack channels. Please try again later.');
      console.error(error);
    }
  }, [error, isError]);

  return {
    data,
    isError,
    isFetching,
    isLoading,
    channels: data && data.channels ? data.channels : [],
  };
};
